import React, { useEffect, useState } from "react";

/*
  BAYİ YÖNETİMİ – FINAL (SERVER + DB UYUMLU)
  ✔ Kurum ekle
  ✔ Kurum listele
  ✔ Kurum sil
  ✔ Login / Logout
*/

const API = "https://api.haymestasarim.com/api";

const HAKEDIS_KADEMELERI = [
  { value: "1", label: "1. Hakediş" },
  { value: "2", label: "2. Hakediş" },
  { value: "3", label: "3. Hakediş" },
];

const ISLEM_TIPLERI = [
  { value: "satis", label: "Satış" },
  { value: "demo", label: "Demo" },
  { value: "yenileme", label: "Yenileme" },
  { value: "kurulum", label: "Kurulum" },
];

function addOneYear(dateValue) {
  if (!dateValue) return "";

  const d = new Date(dateValue);
  if (Number.isNaN(d.getTime())) return "";

  d.setFullYear(d.getFullYear() + 1);
  return d.toISOString().slice(0, 10);
}

function numValue(value) {
  const n = Number(String(value || "0").replace(",", "."));
  return Number.isFinite(n) ? n : 0;
}

function getManuelHakedisOrani(form, kademe) {
  if (!form) return 0;

  const key = `hakedis_${kademe}_oran`;
  return numValue(form[key]);
}

function getSeciliHakedisOrani(form) {
  return getManuelHakedisOrani(form, form?.hakedis_kademe || "1");
}

function hesaplaHakedis(satisTutar, oran) {
  const tutar = numValue(satisTutar);
  const cleanOran = numValue(oran);

  return Math.round(((tutar * cleanOran) / 100) * 100) / 100;
}

function paraFormat(value) {
  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    minimumFractionDigits: 2,
  }).format(numValue(value));
}

export default function AdminLogin() {


/* ================= NETWORK USERS ================= */
const [networkUsers, setNetworkUsers] = useState([]);
const [networkOpen, setNetworkOpen] = useState(false);

const fetchNetworkUsers = async () => {
  try {
    const res = await fetch(`${API}/admin/network/users`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const data = await res.json();
    if (res.ok) setNetworkUsers(data || []);
  } catch (err) {
    console.error("Network kullanıcıları alınamadı", err);
  }
};


/* ================= ÖDEME TALEPLERİ ================= */
const [odemeTalepleri, setOdemeTalepleri] = useState([]);
const [odemeOpen, setOdemeOpen] = useState(false);

const fetchOdemeTalepleri = async () => {
  try {
    const res = await fetch(`${API}/admin/payout-requests`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const data = await res.json();
    if (res.ok) {
      setOdemeTalepleri(data || []);
    }
  } catch (err) {
    console.error("Ödeme talepleri alınamadı", err);
  }
};


/* ================= PAKET BAŞVURULARI ================= */
const [paketBasvurulari, setPaketBasvurulari] = useState([]);
/* ================= PAKET DETAYLARI ================= */
const [paketDetaylari, setPaketDetaylari] = useState([]);


/* ================= PAKET FİLTRE ================= */
const [paketFilter, setPaketFilter] = useState("Tümü");

/* ================= FİLTRELİ PAKET LİSTESİ ================= */
const filteredPaketler = paketBasvurulari.filter(p => {
  if (paketFilter === "Tümü") return true;
  return p.durum === paketFilter;
});

/* ================= PAKET BAŞVURULARINI GETİR ================= */
const fetchPaketBasvurulari = async () => {
  try {
    const res = await fetch(`${API}/admin/paket/basvurular`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const data = await res.json();

    if (res.ok) {
  setPaketBasvurulari(data.basvurular || []);
}


  } catch (err) {
    console.error("Paket başvuruları alınamadı", err);
  }
};


/* 🔽 BURAYA EKLE */
const [token, setToken] = useState(() =>
  localStorage.getItem("admin_token")
);


/* ===== MOBILE FIX (SADECE CSS) ===== */
useEffect(() => {
  const mobileStyle = document.createElement("style");
  mobileStyle.innerHTML = `
    @media (max-width: 768px) {
      .admin-layout {
        display: flex !important;
        flex-direction: column !important;
      }

      .admin-card {
        width: 100% !important;
      }
    }
  `;
  document.head.appendChild(mobileStyle);

  return () => {
    document.head.removeChild(mobileStyle);
  };
}, []);

  /* LOGIN */
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");


function kalanGun(bitisTarihi) {
  const bugun = new Date();
  const bitis = new Date(bitisTarihi);
  const fark = Math.ceil((bitis - bugun) / (1000 * 60 * 60 * 24));
  return fark;
}

function paketBitisTarihi(baslangicTarihi) {
  const baslangic = new Date(baslangicTarihi);
  baslangic.setDate(baslangic.getDate() + 365);
  return baslangic;
}

  /* DATA */
  const [kurumlar, setKurumlar] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);


  /* FORM */
  const [ad, setAd] = useState("");
  const [code, setCode] = useState("");
  const [shortCode, setShortCode] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [adminPassword, setAdminPassword] = useState("");


// ✅ YENİ EKLENENLER
const [kategoriId, setKategoriId] = useState("");
const [il, setIl] = useState("");
const [ilce, setIlce] = useState("");

// ✅ STATE'LER
const [cities, setCities] = useState([]);
const [districts, setDistricts] = useState([]);
const [city, setCity] = useState("");
const [district, setDistrict] = useState("");

/* ================= ŞUBE YÖNETİMİ ================= */
const [subelerByKurum, setSubelerByKurum] = useState({});
const [subeForms, setSubeForms] = useState({});
const [subeLinkForms, setSubeLinkForms] = useState({});
const [subeModeByKurum, setSubeModeByKurum] = useState({});
const [subeLoadingId, setSubeLoadingId] = useState(null);

/* ================= GENEL BAYİ DÜZENLEME ================= */
const [kurumEditOpenById, setKurumEditOpenById] = useState({});
const [kurumEditForms, setKurumEditForms] = useState({});
const [kurumEditLoadingId, setKurumEditLoadingId] = useState(null);


/* ================= REFERANS / SATIŞ İŞLEMLERİ ================= */
const [referansIslemlerByKurum, setReferansIslemlerByKurum] = useState({});
const [referansIslemForms, setReferansIslemForms] = useState({});
const [referansEditByKurum, setReferansEditByKurum] = useState({});

const [referansLoadingId, setReferansLoadingId] = useState(null);

// ✅ İLLERİ GETİR
useEffect(() => {
  fetch(`${API}/auth/locations/tr/cities`)
    .then(r => r.json())
    .then(d => setCities(d || []))
    .catch(err => console.error("CITIES ERROR", err));
}, []);

// ✅ İLÇELERİ GETİR (il seçilince)
useEffect(() => {
  setDistrict("");
  if (!city) {
    setDistricts([]);
    return;
  }
  fetch(`${API}/auth/locations/tr/districts?city_id=${city}`)
    .then(r => r.json())
    .then(d => setDistricts(d || []))
    .catch(err => console.error("DISTRICTS ERROR", err));
}, [city]);


  /* ================= LOGIN ================= */
  const login = async () => {
    setLoading(true);
    setMessage(null);

    try {
      const res = await fetch(`${API}/giris`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (res.ok && data?.token) {
        localStorage.setItem("admin_token", data.token);
        setToken(data.token);
      } else {
        setMessage({ type: "error", text: "Giriş başarısız" });
      }
    } catch {
      setMessage({ type: "error", text: "Sunucuya ulaşılamadı" });
    } finally {
      setLoading(false);
    }
  };

  /* ================= LOGOUT ================= */
  const logout = () => {
    localStorage.removeItem("admin_token");
    setToken(null);
  };

  /* ================= LIST ================= */
  const fetchKurumlar = async () => {
    try {
      const res = await fetch(`${API}/admin/kurumlar`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const json = await res.json();
      setKurumlar(json.data || []);
    } catch {
      setMessage({ type: "error", text: "Bayiler listelenemedi" });
      setKurumlar([]);
    }
  };

useEffect(() => {
  if (token) {
    fetchKurumlar();       // kurumlar
    fetchPaketBasvurulari(); 
    fetchOdemeTalepleri();
 fetchNetworkUsers();
  }
}, [token]);


/* ================= PAKET ONAYLA ================= */
const onaylaPaket = async (b) => {
  try {
const res = await fetch(`${API}/admin/paket/onayla/${b.id}`, {
  method: "POST",
  headers: {
    Authorization: `Bearer ${token}`
  }
});


    if (!res.ok) {
      alert("Paket onaylanamadı");
      return;
    }

    fetchPaketBasvurulari(); // tabloyu yenile
  } catch (err) {
    console.error("Onay hatası", err);
  }
};



  /* ================= CREATE ================= */
  const createKurum = async () => {
    if (!ad || !code || !shortCode || !adminEmail || !adminPassword) {
      setMessage({ type: "error", text: "Tüm alanlar zorunlu" });
      return;
    }

    if (!/^7\d{3}$/.test(code) || !/^7\d{3}$/.test(shortCode)) {
      setMessage({
        type: "error",
        text: "Kurum kodu 7000–7999 arasında olmalı",
      });
      return;
    }

    setLoading(true);
    setMessage(null);

    try {
      const res = await fetch(`${API}/admin/kurumlar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          ad,
          code,
          short_code: shortCode,
          email: adminEmail,
          sifre: adminPassword,
 kategori_id: kategoriId ? Number(kategoriId) : null,
il: city ? Number(city) : null,
ilce: district ? Number(district) : null,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        setMessage({ type: "error", text: data?.message || "Kayıt başarısız" });
        return;
      }

      setMessage({ type: "success", text: "✅ Bayi başarıyla oluşturuldu" });

      /* Form reset */
      setAd("");
      setCode("");
      setShortCode("");
      setAdminEmail("");
      setAdminPassword("");

      /* Listeyi DB’den tekrar al (en sağlam yol) */
      fetchKurumlar();

    } catch {
      setMessage({ type: "error", text: "Sunucu hatası" });
    } finally {
      setLoading(false);
    }
  };

/* ================= ŞUBE FONKSİYONLARI ================= */
const getSubeForm = (oldId) => {
  return subeForms[oldId] || {
    sube_adi: "",
    sube_code: "",
    panel_email: "",
    panel_password: "",
    telefon: "",
    adres: "",
    access_scope: "branch",
  };
};

const getSubeLinkForm = (oldId) => {
  return subeLinkForms[oldId] || {
    kurum_code: "",
    panel_email: "",
  };
};

const getSubeMode = (oldId) => {
  return subeModeByKurum[oldId] || "create";
};

const setSubeMode = (oldId, mode) => {
  setSubeModeByKurum(prev => ({
    ...prev,
    [oldId]: mode,
  }));
};

const setSubeField = (oldId, field, value) => {
  setSubeForms(prev => ({
    ...prev,
    [oldId]: {
      ...getSubeForm(oldId),
      [field]: value,
    },
  }));
};

const setSubeLinkField = (oldId, field, value) => {
  setSubeLinkForms(prev => ({
    ...prev,
    [oldId]: {
      ...getSubeLinkForm(oldId),
      [field]: value,
    },
  }));
};

const fetchSubeler = async (oldId) => {
  if (!oldId) return;

  setSubeLoadingId(oldId);

  try {
    const res = await fetch(`${API}/admin/kurumlar/${oldId}/subeler`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();

    if (!res.ok) {
      setMessage({
        type: "error",
        text: data?.message || "Şubeler alınamadı",
      });
      return;
    }

    setSubelerByKurum(prev => ({
      ...prev,
      [oldId]: {
        kurum: data.kurum,
        data: data.data || [],
      },
    }));
  } catch (err) {
    console.error("Şubeler alınamadı", err);
    setMessage({
      type: "error",
      text: "Şubeler alınamadı",
    });
  } finally {
    setSubeLoadingId(null);
  }
};

const toggleMultiBranch = async (oldId, enabled) => {
  try {
    const res = await fetch(`${API}/admin/kurumlar/${oldId}/multi-branch`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ enabled }),
    });

    const data = await res.json();

    if (!res.ok) {
      setMessage({
        type: "error",
        text: data?.message || "Çok şubeli kullanım güncellenemedi",
      });
      return;
    }

    setMessage({
      type: "success",
      text: data?.message || "Şube ayarı güncellendi",
    });

    await fetchSubeler(oldId);
    fetchKurumlar();
  } catch (err) {
    console.error("Çok şubeli kullanım hatası", err);
    setMessage({
      type: "error",
      text: "Çok şubeli kullanım güncellenemedi",
    });
  }
};

const createSube = async (oldId) => {
  const loadingKey = `create-${oldId}`;

  if (subeLoadingId === loadingKey) return;

  const form = getSubeForm(oldId);

  if (!form.sube_adi.trim()) {
    setMessage({
      type: "error",
      text: "Şube adı zorunlu",
    });
    return;
  }

if (!String(form.sube_code || "").trim()) {
  setMessage({
    type: "error",
    text: "Şube kodu zorunlu",
  });
  return;
}

if (!/^7\d{3}$/.test(String(form.sube_code || "").trim())) {
  setMessage({
    type: "error",
    text: "Şube kodu 7000–7999 arasında olmalı",
  });
  return;
}

if (String(form.panel_email || "").trim() && !String(form.panel_password || "").trim()) {
  setMessage({
    type: "error",
    text: "Panel e-postası girildiyse şifre de zorunlu",
  });
  return;
}

if (
  String(form.panel_password || "").trim() &&
  String(form.panel_password || "").trim().length < 6
) {
  setMessage({
    type: "error",
    text: "Şifre en az 6 karakter olmalı",
  });
  return;
}
setSubeLoadingId(loadingKey);

  try {
    const res = await fetch(`${API}/admin/kurumlar/${oldId}/subeler`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
     
body: JSON.stringify({
  sube_adi: form.sube_adi,
  sube_code: String(form.sube_code || "").trim(),
  panel_email: form.panel_email,
  panel_password: form.panel_password,
  sifre: form.panel_password,
  telefon: form.telefon,
  adres: form.adres,
  access_scope: form.access_scope || "branch",
}),
    });

    const data = await res.json();

    if (!res.ok) {
      setMessage({
        type: "error",
        text: data?.message || "Şube eklenemedi",
      });
      return;
    }

    setMessage({
      type: "success",
      text: "✅ Şube eklendi",
    });

setSubeForms(prev => ({
  ...prev,
  [oldId]: {
    sube_adi: "",
    sube_code: "",
    panel_email: "",
    panel_password: "",
    telefon: "",
    adres: "",
    access_scope: "branch",
  },
}));

    fetchSubeler(oldId);
  } catch (err) {
    console.error("Şube ekleme hatası", err);
    setMessage({
      type: "error",
      text: "Şube eklenemedi",
    });
  } finally {
    setSubeLoadingId(null);
  }
};



const linkExistingKurumAsSube = async (oldId) => {
  if (subeLoadingId === `link-${oldId}`) return;

  const form = getSubeLinkForm(oldId);

  if (!String(form.kurum_code || "").trim()) {
    setMessage({
      type: "error",
      text: "Bağlanacak kurum kodu veya kurum ID zorunlu",
    });
    return;
  }

  setSubeLoadingId(`link-${oldId}`);

  try {
    const res = await fetch(`${API}/admin/kurumlar/${oldId}/subeler/bagla`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        kurum_code: String(form.kurum_code || "").trim(),
        panel_email: form.panel_email,
      }),
    });

    const data = await res.json();

    if (!res.ok) {
      setMessage({
        type: "error",
        text: data?.message || "Mevcut kurum bağlanamadı",
      });
      return;
    }

    setMessage({
      type: "success",
      text: data?.message || "✅ Mevcut kurum şube olarak bağlandı",
    });

    setSubeLinkForms(prev => ({
      ...prev,
      [oldId]: {
        kurum_code: "",
        panel_email: "",
      },
    }));

    await fetchSubeler(oldId);
    fetchKurumlar();
  } catch (err) {
    console.error("Mevcut kurum bağlama hatası", err);
    setMessage({
      type: "error",
      text: "Mevcut kurum bağlanamadı",
    });
  } finally {
    setSubeLoadingId(null);
  }
};




const unlinkExistingKurumAsSube = async (oldId, linkedOldId) => {
  if (!oldId || !linkedOldId) {
    setMessage({
      type: "error",
      text: "Bağlantı ayrılacak kurum bilgisi bulunamadı",
    });
    return;
  }

  const loadingKey = `unlink-${oldId}-${linkedOldId}`;

  if (subeLoadingId === loadingKey) return;

  if (!window.confirm("Bu bağlı kurumu merkezden ayırmak istiyor musun?")) {
    return;
  }

  setSubeLoadingId(loadingKey);

  try {
    const res = await fetch(
      `${API}/admin/kurumlar/${oldId}/subeler/${linkedOldId}/baglantiyi-ayir`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      setMessage({
        type: "error",
        text: data?.message || "Kurum bağlantısı ayrılamadı",
      });
      return;
    }

    setMessage({
      type: "success",
      text: data?.message || "✅ Kurum bağlantısı ayrıldı",
    });

    await fetchSubeler(oldId);
    fetchKurumlar();
  } catch (err) {
    console.error("Kurum bağlantısı ayırma hatası", err);
    setMessage({
      type: "error",
      text: "Kurum bağlantısı ayrılamadı",
    });
  } finally {
    setSubeLoadingId(null);
  }
};




const passiveSube = async (oldId, subeId) => {
  if (!window.confirm("Bu şubeyi pasifleştirmek istiyor musun?")) return;

  try {
    const res = await fetch(`${API}/admin/kurumlar/${oldId}/subeler/${subeId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();

    if (!res.ok) {
      setMessage({
        type: "error",
        text: data?.message || "Şube pasifleştirilemedi",
      });
      return;
    }

    setMessage({
      type: "success",
      text: "Şube pasifleştirildi",
    });

    fetchSubeler(oldId);
  } catch (err) {
    console.error("Şube pasifleştirme hatası", err);
    setMessage({
      type: "error",
      text: "Şube pasifleştirilemedi",
    });
  }
};


/* ================= REFERANS / SATIŞ İŞLEMİ FONKSİYONLARI ================= */
const getReferansForm = (oldId) => {
  return referansIslemForms[oldId] || {
    referans: "",
    firma_adi: "",
    islem_tipi: "satis",
    satilan_urun: "",
    satis_tutari: "",

    hakedis_kademe: "1",
    hakedis_1_oran: "",
    hakedis_2_oran: "",
    hakedis_3_oran: "",

    sozlesme_baslangic: "",
    sozlesme_bitis: "",
    anlasma_notu: "",
  };
};

const setReferansField = (oldId, field, value) => {
  const current = getReferansForm(oldId);

  const nextForm = {
    ...current,
    [field]: value,
  };

  if (field === "sozlesme_baslangic") {
    nextForm.sozlesme_bitis = addOneYear(value);
  }

  setReferansIslemForms(prev => ({
    ...prev,
    [oldId]: nextForm,
  }));
};

const resetReferansForm = (oldId) => {
  setReferansIslemForms(prev => ({
    ...prev,
    [oldId]: {
      referans: "",
      firma_adi: "",
      islem_tipi: "satis",
      satilan_urun: "",
      satis_tutari: "",

      hakedis_kademe: "1",
      hakedis_1_oran: "",
      hakedis_2_oran: "",
      hakedis_3_oran: "",

      sozlesme_baslangic: "",
      sozlesme_bitis: "",
      anlasma_notu: "",
    },
  }));

  setReferansEditByKurum(prev => ({
    ...prev,
    [oldId]: null,
  }));
};

const fetchReferansIslemler = async (oldId) => {
  if (!oldId) return;

  setReferansLoadingId(`list-${oldId}`);

  try {
    const res = await fetch(`${API}/admin/bayilik/islemler/${oldId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      setReferansIslemlerByKurum(prev => ({
        ...prev,
        [oldId]: [],
      }));

      if (res.status !== 404) {
        setMessage({
          type: "error",
          text: data?.message || "Referans / satış işlemleri alınamadı",
        });
      }

      return;
    }

    setReferansIslemlerByKurum(prev => ({
      ...prev,
      [oldId]: data.data || data.islemler || [],
    }));
  } catch (err) {
    console.error("Referans / satış işlemleri alınamadı", err);
    setMessage({
      type: "error",
      text: "Referans / satış işlemleri alınamadı",
    });
  } finally {
    setReferansLoadingId(null);
  }
};

const saveReferansIslem = async (oldId, kurum) => {
  const form = getReferansForm(oldId);
  const editId = referansEditByKurum[oldId];

  if (!String(form.referans || "").trim()) {
    setMessage({
      type: "error",
      text: "Referans / satışçı zorunlu",
    });
    return;
  }

  if (!String(form.firma_adi || "").trim()) {
    setMessage({
      type: "error",
      text: "Firma adı zorunlu",
    });
    return;
  }

  if (!String(form.satilan_urun || "").trim()) {
    setMessage({
      type: "error",
      text: "Satılan ürün / paket zorunlu",
    });
    return;
  }

  const hakedisOrani = getSeciliHakedisOrani(form);
  const hakedisTutari = hesaplaHakedis(form.satis_tutari, hakedisOrani);

  const payload = {
    kurum_old_id: oldId,
    kurum_id: kurum?.id || null,
    kurum_code: kurum?.code || "",
    kurum_short_code: kurum?.short_code || "",

    referans: String(form.referans || "").trim(),
    firma_adi: String(form.firma_adi || "").trim(),
    islem_tipi: form.islem_tipi || "satis",
    satilan_urun: String(form.satilan_urun || "").trim(),

    satis_tutari: numValue(form.satis_tutari),

    hakedis_kademe: form.hakedis_kademe || "1",
    hakedis_1_oran: numValue(form.hakedis_1_oran),
    hakedis_2_oran: numValue(form.hakedis_2_oran),
    hakedis_3_oran: numValue(form.hakedis_3_oran),
    hakedis_orani: hakedisOrani,
    hakedis_tutari: hakedisTutari,

    anlasma_tarihi: form.sozlesme_baslangic || null,
    sozlesme_baslangic: form.sozlesme_baslangic || null,
    sozlesme_bitis: form.sozlesme_bitis || addOneYear(form.sozlesme_baslangic) || null,

    anlasma_notu: String(form.anlasma_notu || "").trim(),
  };

  const loadingKey = editId ? `update-${editId}` : `create-${oldId}`;
  setReferansLoadingId(loadingKey);

  try {
    const res = await fetch(
      editId
        ? `${API}/admin/bayilik/islemler/${editId}`
        : `${API}/admin/bayilik/islemler`,
      {
        method: editId ? "PUT" : "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      setMessage({
        type: "error",
        text: data?.message || "İşlem kaydı kaydedilemedi",
      });
      return;
    }

    setMessage({
      type: "success",
      text: editId
        ? "✅ İşlem kaydı güncellendi"
        : "✅ İşlem kaydı kaydedildi",
    });

    resetReferansForm(oldId);
    await fetchReferansIslemler(oldId);
  } catch (err) {
    console.error("Referans / satış işlem kayıt hatası", err);
    setMessage({
      type: "error",
      text: "İşlem kaydı kaydedilemedi",
    });
  } finally {
    setReferansLoadingId(null);
  }
};

const editReferansIslem = (oldId, row) => {
  setReferansEditByKurum(prev => ({
    ...prev,
    [oldId]: row.id,
  }));

  setReferansIslemForms(prev => ({
    ...prev,
    [oldId]: {
      referans: row.referans || "",
      firma_adi: row.firma_adi || "",
      islem_tipi: row.islem_tipi || "satis",
      satilan_urun: row.satilan_urun || "",
      satis_tutari: row.satis_tutari || "",

      hakedis_kademe: row.hakedis_kademe || "1",
      hakedis_1_oran: row.hakedis_1_oran ?? "",
      hakedis_2_oran: row.hakedis_2_oran ?? "",
      hakedis_3_oran: row.hakedis_3_oran ?? "",

      sozlesme_baslangic: row.sozlesme_baslangic
        ? String(row.sozlesme_baslangic).slice(0, 10)
        : "",

      sozlesme_bitis: row.sozlesme_bitis
        ? String(row.sozlesme_bitis).slice(0, 10)
        : addOneYear(row.sozlesme_baslangic),

      anlasma_notu: row.anlasma_notu || "",
    },
  }));
};

const deleteReferansIslem = async (oldId, id) => {
  if (!id) return;

  if (!window.confirm("Bu işlem kaydını silmek istiyor musun?")) return;

  setReferansLoadingId(`delete-${id}`);

  try {
    const res = await fetch(`${API}/admin/bayilik/islemler/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      setMessage({
        type: "error",
        text: data?.message || "İşlem kaydı silinemedi",
      });
      return;
    }

    setMessage({
      type: "success",
      text: "✅ İşlem kaydı silindi",
    });

    resetReferansForm(oldId);
    await fetchReferansIslemler(oldId);
  } catch (err) {
    console.error("Referans / satış işlem silme hatası", err);
    setMessage({
      type: "error",
      text: "İşlem kaydı silinemedi",
    });
  } finally {
    setReferansLoadingId(null);
  }
};



const formatSimpleDate = (value) => {








  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("tr-TR");
};

/* ================= GENEL BAYİ DÜZENLEME FONKSİYONLARI ================= */
const getKurumEditForm = (oldId) => {
  return kurumEditForms[oldId] || {
    ad: "",
    code: "",
    short_code: "",
    email: "",
    sifre: "",
  };
};

const openKurumEdit = (k) => {
  const oldId = k.old_id;

  setKurumEditOpenById(prev => ({
    ...prev,
    [oldId]: !prev[oldId],
  }));

  setKurumEditForms(prev => ({
    ...prev,
    [oldId]: {
      ad: k.ad || "",
      code: k.code || "",
      short_code: k.short_code || "",
email:
  k.email ||
  k.admin_email ||
  k.panel_email ||
  k.user_email ||
  k.kullanici_email ||
  k.admin_mail ||
  k.mail ||
  "",
      sifre: "",
    },
  }));
};

const setKurumEditField = (oldId, field, value) => {
  setKurumEditForms(prev => ({
    ...prev,
    [oldId]: {
      ...getKurumEditForm(oldId),
      [field]: value,
    },
  }));
};

const cancelKurumEdit = (oldId) => {
  setKurumEditOpenById(prev => ({
    ...prev,
    [oldId]: false,
  }));

  setKurumEditForms(prev => ({
    ...prev,
    [oldId]: {
      ad: "",
      code: "",
      short_code: "",
      email: "",
      sifre: "",
    },
  }));
};

const saveKurumEdit = async (oldId) => {
  const form = getKurumEditForm(oldId);

  if (!String(form.ad || "").trim()) {
    setMessage({ type: "error", text: "İşletme adı zorunlu" });
    return;
  }

  if (!/^7\d{3}$/.test(String(form.code || "").trim())) {
    setMessage({ type: "error", text: "Kurum kodu 7000–7999 arasında olmalı" });
    return;
  }

  if (!/^7\d{3}$/.test(String(form.short_code || "").trim())) {
    setMessage({ type: "error", text: "Short code 7000–7999 arasında olmalı" });
    return;
  }

  if (!String(form.email || "").trim()) {
    setMessage({ type: "error", text: "Panel e-posta zorunlu" });
    return;
  }

  if (
    String(form.sifre || "").trim() &&
    String(form.sifre || "").trim().length < 6
  ) {
    setMessage({ type: "error", text: "Yeni şifre en az 6 karakter olmalı" });
    return;
  }

  setKurumEditLoadingId(oldId);

  try {
    const payload = {
      ad: String(form.ad || "").trim(),
      code: String(form.code || "").trim(),
      short_code: String(form.short_code || "").trim(),
      email: String(form.email || "").trim(),
    };

    if (String(form.sifre || "").trim()) {
      payload.sifre = String(form.sifre || "").trim();
      payload.password = String(form.sifre || "").trim();
      payload.admin_password = String(form.sifre || "").trim();
    }

    const res = await fetch(`${API}/admin/kurumlar/${oldId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      setMessage({
        type: "error",
        text: data?.message || "Bayi bilgileri güncellenemedi",
      });
      return;
    }

    setMessage({
      type: "success",
      text: "✅ Bayi bilgileri güncellendi",
    });

    cancelKurumEdit(oldId);
    fetchKurumlar();
  } catch (err) {
    console.error("Bayi düzenleme hatası", err);
    setMessage({
      type: "error",
      text: "Bayi bilgileri güncellenemedi",
    });
  } finally {
    setKurumEditLoadingId(null);
  }
};

  /* ================= DELETE ================= */
  const deleteKurum = async (oldId) => {
    if (!oldId) {
      setMessage({ type: "error", text: "Kurum ID bulunamadı" });
      return;
    }

    if (!window.confirm("Bu bayiyi tamamen silmek istiyor musun?")) return;

    await fetch(`${API}/admin/kurumlar/${oldId}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });

    fetchKurumlar();
  };



/* ================= PANEL USER DELETE ================= */
const deletePanelUser = async (panelUserId) => {
  if (!window.confirm("Bu kullanıcıyı networkten çıkarmak istiyor musun?")) return;

  try {
    const res = await fetch(
      `${API}/admin/network/remove-user/${panelUserId}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) {
      alert("Kullanıcı çıkarılamadı");
      return;
    }

  } catch (err) {
    console.error("Panel user silme hatası", err);
  }
};
/* ================= NETWORK USER DELETE ================= */
const deactivateNetworkUser = async (userId) => {
  if (!window.confirm("Bu network kullanıcısı sistemden çıkarılsın mı?"))
    return;

  const res = await fetch(
    `${API}/admin/network/deactivate-user/${userId}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ status: "left" })
    }
  );

  if (!res.ok) {
    alert("Network kullanıcısı silinemedi");
    return;
  }

  fetchNetworkUsers();
};

  /* ================= LOGIN UI ================= */
  if (!token) {
    return (
      <div style={styles.loginPage}>
        <div style={styles.loginCard}>
          <h2>BAYİ YÖNETİMİ</h2>
          <input style={styles.input} placeholder="E-posta" onChange={e => setEmail(e.target.value)} />
          <input style={styles.input} type="password" placeholder="Şifre" onChange={e => setPassword(e.target.value)} />
          <button style={styles.primaryBtn} onClick={login}>
            {loading ? "Bekleyin..." : "Giriş Yap"}
          </button>
        </div>
      </div>
    );
  }

  /* ================= FILTER ================= */
const filtered = kurumlar
  // 🔴 PANEL USER SATIRLARINI AT
  .filter(k => k.code && k.short_code)
  // 🔍 ARAMA
  .filter(k =>
    `${k.ad} ${k.code}`.toLowerCase().includes(search.toLowerCase())
  );

  /* ================= PANEL ================= */
  return (
    <div style={styles.page}>
     <div style={styles.hero}>
  <div>
    <div style={styles.kicker}>MesYat Digital Admin Panel</div>
    <h1 style={styles.heroTitle}>Bayi Yönetimi</h1>
    <p style={styles.heroText}>
      Bayi kayıtlarını, paket başvurularını, ödeme taleplerini ve network kullanıcılarını tek ekrandan yönetin.
    </p>
  </div>

  <div style={styles.heroActions}>
    <div style={styles.heroBadge}>
      <span style={styles.heroDot}></span>
      Aktif Oturum
    </div>

    <button style={styles.logoutBtn} onClick={logout}>
      Çıkış
    </button>
  </div>
</div>

      {message && (
        <div style={{
          ...styles.message,
          background: message.type === "error" ? "#fee2e2" : "#dcfce7",
          color: message.type === "error" ? "#991b1b" : "#166534"
        }}>
          {message.text}
        </div>
      )}
<div style={styles.statsGrid}>
  <div style={styles.statCard}>
    <span style={styles.statIcon}>🏢</span>
    <div>
      <div style={styles.statLabel}>Toplam Bayi</div>
      <div style={styles.statValue}>{filtered.length}</div>
    </div>
  </div>

  <div style={styles.statCard}>
    <span style={styles.statIcon}>📦</span>
    <div>
      <div style={styles.statLabel}>Paket Başvurusu</div>
      <div style={styles.statValue}>{paketBasvurulari.length}</div>
    </div>
  </div>

  <div style={styles.statCard}>
    <span style={styles.statIcon}>💸</span>
    <div>
      <div style={styles.statLabel}>Ödeme Talebi</div>
      <div style={styles.statValue}>{odemeTalepleri.length}</div>
    </div>
  </div>

  <div style={styles.statCard}>
    <span style={styles.statIcon}>🌐</span>
    <div>
      <div style={styles.statLabel}>Network Kullanıcı</div>
      <div style={styles.statValue}>{networkUsers.length}</div>
    </div>
  </div>
</div>

<div style={styles.layout} className="admin-layout">
  <div style={styles.card} className="admin-card">
    <div style={styles.cardHeader}>
      <div>
        <div style={styles.cardEyebrow}>Yeni kayıt</div>
        <h3 style={styles.cardTitle}>Yeni Bayi Ekle</h3>
      </div>
      <div style={styles.cardIcon}>＋</div>
    </div>

    <div style={styles.formGrid}>
      <input style={styles.input} placeholder="Kurum Adı" value={ad} onChange={e => setAd(e.target.value)} />
      <input style={styles.input} placeholder="Kurum Kodu" value={code} onChange={e => setCode(e.target.value)} />
      <input style={styles.input} placeholder="Short Code" value={shortCode} onChange={e => setShortCode(e.target.value)} />
      <input style={styles.input} placeholder="Admin E-posta" value={adminEmail} onChange={e => setAdminEmail(e.target.value)} />
      <input style={styles.input} placeholder="Admin Şifre" value={adminPassword} onChange={e => setAdminPassword(e.target.value)} />

      <select
        style={styles.input}
        value={kategoriId}
        onChange={e => setKategoriId(e.target.value)}
      >
        <option value="">Kategori Seç</option>
        <option value="1">Sağlık</option>
        <option value="2">Eğitim</option>
        <option value="3">Restoran</option>
        <option value="4">Spor</option>
        <option value="5">STK</option>
        <option value="6">Finans</option>
        <option value="7">Teknoloji</option>
        <option value="8">Turizm</option>
        <option value="9">Danışmanlık</option>
        <option value="10">Emlak</option>
        <option value="11">Hizmet</option>
        <option value="12">Üretim</option>
        <option value="13">Otomotiv</option>
        <option value="14">Medya</option>
        <option value="15">Enerji</option>
        <option value="16">Kişisel Gelişim</option>
        <option value="17">Diğer</option>
      </select>

      <select
        style={styles.input}
        value={city}
        onChange={e => setCity(e.target.value)}
      >
        <option value="">İl Seçiniz</option>
        {cities.map(c => (
          <option key={c.id} value={c.id}>{c.name}</option>
        ))}
      </select>

      <select
        style={{
          ...styles.input,
          opacity: districts.length ? 1 : 0.65,
          cursor: districts.length ? "pointer" : "not-allowed"
        }}
        value={district}
        disabled={!districts.length}
        onChange={e => setDistrict(e.target.value)}
      >
        <option value="">İlçe Seçiniz</option>
        {districts.map(d => (
          <option key={d.id} value={d.id}>{d.name}</option>
        ))}
      </select>
    </div>

    <button style={styles.primaryBtn} onClick={createKurum}>
      {loading ? "Kaydediliyor..." : "Bayiyi Kaydet"}
    </button>
  </div>

  <div style={styles.card}>
    <div style={styles.cardHeader}>
      <div>
        <div style={styles.cardEyebrow}>Kayıtlı işletmeler</div>
        <h3 style={styles.cardTitle}>Bayiler ({filtered.length})</h3>
      </div>
      <div style={styles.cardIcon}>🏢</div>
    </div>

    <input
      style={styles.searchInput}
      placeholder="Bayi adı veya kurum kodu ara..."
      value={search}
      onChange={e => setSearch(e.target.value)}
    />

    <div style={styles.bayiList}>
     


{filtered.map(k => {
  const subeState = subelerByKurum[k.old_id];
  const subeler = subeState?.data || [];
  const kurumSubeInfo = subeState?.kurum || k;
  const multiBranchEnabled = !!kurumSubeInfo.multi_branch_enabled;
  const subeForm = getSubeForm(k.old_id);
  const subeLinkForm = getSubeLinkForm(k.old_id);
  const subeMode = getSubeMode(k.old_id);

const kurumEditOpen = !!kurumEditOpenById[k.old_id];
const kurumEditForm = getKurumEditForm(k.old_id);

const referansForm = getReferansForm(k.old_id);
const referansIslemler = referansIslemlerByKurum[k.old_id] || [];
const referansEditId = referansEditByKurum[k.old_id];

  return (
    <details
      key={k.old_id}
      style={styles.accordion}
      
onToggle={(e) => {
  if (e.currentTarget.open) {
    if (!subelerByKurum[k.old_id]) {
      fetchSubeler(k.old_id);
    }

    if (!referansIslemlerByKurum[k.old_id]) {
      fetchReferansIslemler(k.old_id);
    }
  }
}}

    >
      <summary style={styles.summary}>
        <div style={styles.bayiSummaryLeft}>
          <div style={styles.avatar}>
            {String(k.ad || "?").charAt(0).toUpperCase()}
          </div>

          <div>
            <div style={styles.bayiName}>{k.ad}</div>
            <div style={styles.bayiMeta}>
              Kod: <b>{k.code}</b> · Short: <b>{k.short_code}</b>
            </div>
          </div>
        </div>

        <span style={styles.statusBadge}>Aktif</span>
      </summary>

      <div style={styles.detail}>
        <div style={styles.detailGrid}>
          <div style={styles.infoBox}>
            <span style={styles.infoLabel}>Kurum ID</span>
            <b>{k.old_id}</b>
          </div>

          <div style={styles.infoBox}>
            <span style={styles.infoLabel}>Kurum Kodu</span>
            <b>{k.code}</b>
          </div>

          <div style={styles.infoBox}>
            <span style={styles.infoLabel}>Short Code</span>
            <b>{k.short_code}</b>
          </div>
        </div>

        {/* ================= GENEL BAYİ DÜZENLEME ================= */}
        <div style={styles.kurumEditBox}>
          <div style={styles.kurumEditTop}>
            <div>
              <div style={styles.kurumEditTitle}>⚙️ Genel Bayi Bilgileri</div>
              <div style={styles.kurumEditDesc}>
                İşletme adı, kurum kodu, short code, panel e-posta ve şifre bilgisini buradan güncelleyebilirsin.
              </div>
            </div>

            <button
              type="button"
              style={styles.kurumEditToggleBtn}
              onClick={() => openKurumEdit(k)}
            >
              {kurumEditOpen ? "Düzenlemeyi Kapat" : "Genel Bilgileri Düzenle"}
            </button>
          </div>

          {kurumEditOpen && (
            <div style={styles.kurumEditForm}>
              <input
                style={styles.input}
                placeholder="İşletme / Kurum Adı"
                value={kurumEditForm.ad}
                onChange={e => setKurumEditField(k.old_id, "ad", e.target.value)}
              />

              <input
                style={styles.input}
                placeholder="Kurum Kodu Örn: 7054"
                value={kurumEditForm.code}
                onChange={e => setKurumEditField(k.old_id, "code", e.target.value)}
              />

              <input
                style={styles.input}
                placeholder="Short Code Örn: 7054"
                value={kurumEditForm.short_code}
                onChange={e => setKurumEditField(k.old_id, "short_code", e.target.value)}
              />

              <input
                style={styles.input}
                placeholder="Panel Admin E-posta"
                value={kurumEditForm.email}
                onChange={e => setKurumEditField(k.old_id, "email", e.target.value)}
              />

             <input
  style={styles.input}
  type="password"
  placeholder="Yeni şifre gir - boş bırakırsan mevcut şifre korunur"
  value={kurumEditForm.sifre}
  onChange={e => setKurumEditField(k.old_id, "sifre", e.target.value)}
/>

            <div style={styles.kurumEditPasswordNote}>
  Mevcut şifre güvenlik nedeniyle gösterilmez. Yeni şifre yazarsan değişir, boş bırakırsan korunur.
</div>

              <div style={styles.kurumEditActions}>
                <button
                  type="button"
                  style={{
                    ...styles.kurumEditSaveBtn,
                    opacity: kurumEditLoadingId === k.old_id ? 0.65 : 1,
                    cursor: kurumEditLoadingId === k.old_id ? "not-allowed" : "pointer",
                  }}
                  disabled={kurumEditLoadingId === k.old_id}
                  onClick={() => saveKurumEdit(k.old_id)}
                >
                  {kurumEditLoadingId === k.old_id
                    ? "Güncelleniyor..."
                    : "Bayi Bilgilerini Güncelle"}
                </button>

                <button
                  type="button"
                  style={styles.kurumEditCancelBtn}
                  onClick={() => cancelKurumEdit(k.old_id)}
                >
                  Vazgeç
                </button>
              </div>
            </div>
          )}
        </div>

        {/* ================= ŞUBE YÖNETİMİ ================= */}
        <div style={styles.subeBox}>
          <div style={styles.subeTop}>
            <div>
              <div style={styles.subeTitle}>Şube Yönetimi</div>
              <div style={styles.subeDesc}>
                Bu bayiye bağlı Merkez ve diğer şubeleri buradan yönetebilirsin.
              </div>
            </div>

            <button
              type="button"
              style={{
                ...styles.subeToggleBtn,
                background: multiBranchEnabled ? "#16a34a" : "#64748b",
              }}
              onClick={() => toggleMultiBranch(k.old_id, !multiBranchEnabled)}
            >
              {multiBranchEnabled ? "Çok Şubeli Açık" : "Çok Şubeli Kapalı"}
            </button>
          </div>

          <button
            type="button"
            style={styles.subeRefreshBtn}
            onClick={() => fetchSubeler(k.old_id)}
          >
            {subeLoadingId === k.old_id
              ? "Şubeler yükleniyor..."
              : "Şubeleri Göster / Yenile"}
          </button>

          <div style={styles.subeList}>
            {subeler.map(s => (
              <div key={s.id} style={styles.subeItem}>
                <div>
                  <div style={styles.subeName}>
                    {s.sube_adi}

{s.is_default && (
  <span style={styles.defaultBadge}>Merkez</span>
)}

{s.source_type === "linked" && (
  <span style={styles.linkedBadge}>Bağlı Kurum</span>
)}

{!s.aktif && (
  <span style={styles.passiveBadge}>Pasif</span>
)}
                  </div>

                 <div style={styles.subeMeta}>
  Kod: <b>{s.sube_code || "-"}</b> · Yetki:{" "}
  <b>{s.access_scope === "all" ? "Tüm şubeler" : "Sadece bu şube"}</b>
</div>

<div style={styles.subeMeta}>
  Panel: <b>{s.panel_email || "Panel e-postası yok"}</b>
</div>

<div style={styles.subeMeta}>
  {s.telefon || "Telefon yok"} · {s.adres || "Adres yok"}
</div>

                </div>

           {s.source_type === "linked" && s.linked_old_id && (
 <button
  type="button"
  style={{
    ...styles.subeDangerLightBtn,
    opacity:
      subeLoadingId === `unlink-${k.old_id}-${s.linked_old_id}` ? 0.65 : 1,
    cursor:
      subeLoadingId === `unlink-${k.old_id}-${s.linked_old_id}`
        ? "not-allowed"
        : "pointer",
  }}
  disabled={subeLoadingId === `unlink-${k.old_id}-${s.linked_old_id}`}
  onClick={() => unlinkExistingKurumAsSube(k.old_id, s.linked_old_id)}
>
  {subeLoadingId === `unlink-${k.old_id}-${s.linked_old_id}`
    ? "Ayrılıyor..."
    : "Bağlantıyı Ayır"}
</button>
)}

{s.source_type !== "linked" && !s.is_default && s.aktif && (
  <button
    type="button"
    style={styles.subePassiveBtn}
    onClick={() => passiveSube(k.old_id, s.id)}
  >
    Pasifleştir
  </button>
)}
              </div>
            ))}

            {!subeler.length && (
              <div style={styles.subeEmpty}>
                Şube bilgisi henüz yüklenmedi. “Şubeleri Göster / Yenile” butonuna bas.
              </div>
            )}
          </div>


<div style={styles.subeTabs}>
  <button
    type="button"
    style={{
      ...styles.subeTabBtn,
      background: subeMode === "create" ? "#2563eb" : "#e2e8f0",
      color: subeMode === "create" ? "#fff" : "#0f172a",
    }}
    onClick={() => setSubeMode(k.old_id, "create")}
  >
    Yeni Şube Aç
  </button>

  <button
    type="button"
    style={{
      ...styles.subeTabBtn,
      background: subeMode === "link" ? "#f97316" : "#e2e8f0",
      color: subeMode === "link" ? "#fff" : "#0f172a",
    }}
    onClick={() => setSubeMode(k.old_id, "link")}
  >
    Mevcut Kurumu Bağla
  </button>
</div>

{subeMode === "create" && (
  <>
    <div style={styles.subeHelper}>
      Yeni şube açarken daha önce kullanılmamış yeni bir kod gir. Örnek: 7061.  
      Zaten açılmış bir kurum kodunu burada kullanma.
    </div>

    <div style={styles.subeForm}>
      <input
        style={styles.input}
        placeholder="Yeni Şube Adı"
        value={subeForm.sube_adi}
        onChange={e => setSubeField(k.old_id, "sube_adi", e.target.value)}
      />

      <input
        style={styles.input}
        placeholder="Yeni Şube Kodu Örn: 7061"
        value={subeForm.sube_code}
        onChange={e => setSubeField(k.old_id, "sube_code", e.target.value)}
      />

    <input
  style={styles.input}
  type="password"
  placeholder="Panel Şifre"
  value={subeForm.panel_password}
  onChange={e => setSubeField(k.old_id, "panel_password", e.target.value)}
/>

      <select
        style={styles.input}
        value={subeForm.access_scope}
        onChange={e => setSubeField(k.old_id, "access_scope", e.target.value)}
      >
        <option value="branch">Sadece bu şube</option>
        <option value="all">Tüm şubeler</option>
      </select>

      <input
        style={styles.input}
        placeholder="Telefon"
        value={subeForm.telefon}
        onChange={e => setSubeField(k.old_id, "telefon", e.target.value)}
      />

      <input
        style={styles.input}
        placeholder="Adres"
        value={subeForm.adres}
        onChange={e => setSubeField(k.old_id, "adres", e.target.value)}
      />

    <button
  type="button"
  style={{
    ...styles.subeAddBtn,
    opacity: subeLoadingId === `create-${k.old_id}` ? 0.65 : 1,
    cursor: subeLoadingId === `create-${k.old_id}` ? "not-allowed" : "pointer",
  }}
  disabled={subeLoadingId === `create-${k.old_id}`}
  onClick={() => createSube(k.old_id)}
>
  {subeLoadingId === `create-${k.old_id}`
    ? "Şube oluşturuluyor..."
    : "Yeni Şubeyi Oluştur"}
</button>
    </div>
  </>
)}

{subeMode === "link" && (
  <>
    <div style={styles.subeHelper}>
      Zaten ayrı admin olarak açılmış kurumu merkeze bağlamak için kurum kodu veya kurum ID gir.  
      Örnek: Ateş Cafe merkez 7047 ise, bağlanacak kurum 7060 olabilir.
    </div>

    <div style={styles.subeForm}>
      <input
        style={styles.input}
        placeholder="Mevcut Kurum Kodu veya ID Örn: 7060 / 401"
        value={subeLinkForm.kurum_code}
        onChange={e => setSubeLinkField(k.old_id, "kurum_code", e.target.value)}
      />

      <input
        style={styles.input}
        placeholder="Panel E-posta Opsiyonel"
        value={subeLinkForm.panel_email}
        onChange={e => setSubeLinkField(k.old_id, "panel_email", e.target.value)}
      />

    <button
  type="button"
  style={{
    ...styles.subeLinkBtn,
    opacity: subeLoadingId === `link-${k.old_id}` ? 0.65 : 1,
    cursor: subeLoadingId === `link-${k.old_id}` ? "not-allowed" : "pointer",
  }}
  disabled={subeLoadingId === `link-${k.old_id}`}
  onClick={() => linkExistingKurumAsSube(k.old_id)}
>
  {subeLoadingId === `link-${k.old_id}`
    ? "Bağlanıyor..."
    : "Mevcut Kurumu Bu Merkeze Bağla"}
</button>
    </div>
  </>
)}

        </div>


        {/* ================= REFERANS / SATIŞ İŞLEMLERİ ================= */}
        <div style={styles.referansBox}>
          <div style={styles.referansTop}>
            <div>
              <div style={styles.referansTitle}>🤝 Referans / Satış İşlemleri</div>
              <div style={styles.referansDesc}>
                Bu bölüm sadece bilgi amaçlıdır. Ödeme, tahsilat, hak ediş veya fatura takibi değildir.
              </div>
            </div>

            <div style={styles.referansInfoBadge}>
              Bilgi Kaydı
            </div>
          </div>

          <div style={styles.referansForm}>
            <input
              style={styles.input}
              placeholder="Referans / Satışçı Örn: Olcay"
              value={referansForm.referans}
              onChange={e => setReferansField(k.old_id, "referans", e.target.value)}
            />

            <input
              style={styles.input}
              placeholder="Firma / İşletme Adı Örn: Bursa X Cafe"
              value={referansForm.firma_adi}
              onChange={e => setReferansField(k.old_id, "firma_adi", e.target.value)}
            />

            <input
              style={styles.input}
              placeholder="Satılan Ürün / Paket Örn: QR Menü + Stok"
              value={referansForm.satilan_urun}
              onChange={e => setReferansField(k.old_id, "satilan_urun", e.target.value)}
            />

        <select
  style={styles.input}
  value={referansForm.islem_tipi}
  onChange={e => setReferansField(k.old_id, "islem_tipi", e.target.value)}
>
  {ISLEM_TIPLERI.map(opt => (
    <option key={opt.value} value={opt.value}>
      {opt.label}
    </option>
  ))}
</select>

<input
  style={styles.input}
  type="number"
  min="0"
  step="0.01"
  placeholder="Satış Tutarı Örn: 20000"
  value={referansForm.satis_tutari}
  onChange={e => setReferansField(k.old_id, "satis_tutari", e.target.value)}
/>



<div style={styles.kademeTabs}>
  {HAKEDIS_KADEMELERI.map(kademe => {
    const oranKey = `hakedis_${kademe.value}_oran`;

    return (
      <div
        key={kademe.value}
        style={{
          ...styles.kademeManualBox,
          borderColor:
            referansForm.hakedis_kademe === kademe.value
              ? "#2563eb"
              : "#e2e8f0",
          background:
            referansForm.hakedis_kademe === kademe.value
              ? "#eff6ff"
              : "#f8fafc",
        }}
      >
        <button
          type="button"
          style={{
            ...styles.kademeSelectBtn,
            background:
              referansForm.hakedis_kademe === kademe.value
                ? "#2563eb"
                : "#e2e8f0",
            color:
              referansForm.hakedis_kademe === kademe.value
                ? "#fff"
                : "#0f172a",
          }}
          onClick={() =>
            setReferansField(k.old_id, "hakedis_kademe", kademe.value)
          }
        >
          {kademe.label}
        </button>

        <input
          style={styles.kademeInput}
          type="number"
          min="0"
          max="100"
          step="0.01"
          placeholder="Oran %"
          value={referansForm[oranKey]}
          onChange={e =>
            setReferansField(k.old_id, oranKey, e.target.value)
          }
        />
      </div>
    );
  })}
</div>


<div style={styles.hakedisPreviewMini}>
  <div>
    <span>Satış</span>
    <b>{paraFormat(referansForm.satis_tutari)}</b>
  </div>

  <div>
  <span>Oran</span>
  <b>%{getSeciliHakedisOrani(referansForm)}</b>
</div>

<div>
  <span>Bilgi Amaçlı Hak Ediş</span>
  <b>
    {paraFormat(
      hesaplaHakedis(
        referansForm.satis_tutari,
        getSeciliHakedisOrani(referansForm)
      )
    )}
  </b>
</div>
</div>

<div style={styles.dateFieldBox}>
  <label style={styles.dateLabel}>
    {referansForm.islem_tipi === "demo"
      ? "Demo Tarihi"
      : "Sözleşme Başlangıç Tarihi"}
  </label>

  <input
    style={styles.input}
    type="date"
    value={referansForm.sozlesme_baslangic}
    onChange={e =>
      setReferansField(k.old_id, "sozlesme_baslangic", e.target.value)
    }
  />
</div>

<div style={styles.dateFieldBox}>
  <label style={styles.dateLabel}>
    Otomatik Bitiş Tarihi
  </label>

  <input
    style={{
      ...styles.input,
      background: "#f1f5f9",
      color: "#475569",
      cursor: "not-allowed",
    }}
    type="date"
    value={referansForm.sozlesme_bitis}
    readOnly
  />
</div>

            <textarea
              style={styles.referansTextArea}
              placeholder="Not: anlaşma detayı, hangi modüller verildi, özel açıklama..."
              value={referansForm.anlasma_notu}
              onChange={e => setReferansField(k.old_id, "anlasma_notu", e.target.value)}
            />

            <div style={styles.referansActions}>
              <button
                type="button"
                style={styles.referansSaveBtn}
                onClick={() => saveReferansIslem(k.old_id, k)}
              >
                {referansEditId ? "İşlemi Güncelle" : "İşlemi Kaydet"}
              </button>

              {referansEditId && (
                <button
                  type="button"
                  style={styles.referansCancelBtn}
                  onClick={() => resetReferansForm(k.old_id)}
                >
                  Vazgeç
                </button>
              )}
            </div>
          </div>

          <div style={styles.referansList}>
            {referansIslemler.map(row => (
              <div key={row.id} style={styles.referansItem}>
                <div style={styles.referansItemMain}>
                  <div style={styles.referansItemHeader}>
                    <b>{row.firma_adi}</b>
                    <span style={styles.referansSmallBadge}>
                      {row.referans}
                    </span>
                  </div>

              <div style={styles.referansMeta}>
  İşlem Tipi: <b>{ISLEM_TIPLERI.find(x => x.value === row.islem_tipi)?.label || "Satış"}</b>
</div>

<div style={styles.referansMeta}>
  Satılan: <b>{row.satilan_urun}</b>
</div>

<div style={styles.referansMeta}>
  Satış Tutarı: <b>{paraFormat(row.satis_tutari)}</b> · Kademe:{" "}
  <b>{row.hakedis_kademe || "1"}. Hakediş</b> · Oran:{" "}
<b>%{row.hakedis_orani || 0}</b>
</div>

<div style={styles.referansMeta}>
  Bilgi Amaçlı Hak Ediş:{" "}
 <b>{paraFormat(row.hakedis_tutari || hesaplaHakedis(row.satis_tutari, row.hakedis_orani))}</b>
</div>

<div style={styles.referansMeta}>
  Tarih: <b>{formatSimpleDate(row.sozlesme_baslangic)}</b> -{" "}
  <b>{formatSimpleDate(row.sozlesme_bitis)}</b>
</div>

                  {row.anlasma_notu && (
                    <div style={styles.referansNote}>
                      {row.anlasma_notu}
                    </div>
                  )}
                </div>

                <div style={styles.referansItemActions}>
                  <button
                    type="button"
                    style={styles.referansEditBtn}
                    onClick={() => editReferansIslem(k.old_id, row)}
                  >
                    Düzenle
                  </button>

                  <button
                    type="button"
                    style={styles.referansDeleteBtn}
                    onClick={() => deleteReferansIslem(k.old_id, row.id)}
                  >
                    Sil
                  </button>
                </div>
              </div>
            ))}

            {!referansIslemler.length && (
              <div style={styles.referansEmpty}>
                Henüz işlem kaydı yok. Bu bayinin getirdiği firma ve satılan ürünü yukarıdan ekleyebilirsin.
              </div>
            )}
          </div>
        </div>

        <button
          style={styles.deleteBtn}
          onClick={() => deleteKurum(k.old_id)}
        >
          Bayiyi Sil
        </button>
      </div>
    </details>
  );
})}


      {!filtered.length && (
        <div style={styles.emptyState}>
          <div style={styles.emptyIcon}>🔍</div>
          <b>Kayıt bulunamadı</b>
          <span>Arama kriterini değiştirerek tekrar deneyebilirsin.</span>
        </div>
      )}
    </div>
  </div>
</div>      
      {/* ================= KURUMSAL PAKET BAŞVURULARI ================= */}
      <div style={{ marginTop: 40 }}>
        <div style={styles.card}>
<h3>📦 Paket Başvuruları (Kurumsal)</h3>

<div style={{ display: "flex", gap: 10, margin: "10px 0 20px" }}>
  {["Tümü", "Beklemede", "Onaylandı"].map(f => (
    <button
      key={f}
      onClick={() => setPaketFilter(f)}
      style={{
        padding: "8px 14px",
        borderRadius: 8,
        border: "none",
        cursor: "pointer",
        fontWeight: 700,
        background:
          paketFilter === f
            ? "#2563eb"
            : "#e5e7eb",
        color:
          paketFilter === f
            ? "#fff"
            : "#111827"
      }}
    >
      {f}
    </button>
  ))}
</div>

          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "#f1f5f9", textAlign: "left" }}>
                  <th style={styles.th}>Başvuran</th>
                  <th style={styles.th}>Referans</th>
 <th style={styles.th}>Paket</th>
<th style={styles.th}>Başlangıç</th>
<th style={styles.th}>Bitiş</th>
<th style={styles.th}>Kalan Süre</th>
<th style={styles.th}>Durum</th>

                  <th style={styles.th}>İşlem</th>
                </tr>
              </thead>
<tbody>
{filteredPaketler.map(b => {
 const baslangic = b.baslangic_tarihi
  ? new Date(b.baslangic_tarihi)
  : null;

const bitis = b.bitis_tarihi
  ? new Date(b.bitis_tarihi)
  : null;

const gun = bitis ? kalanGun(bitis) : null;



    return (
      <tr key={b.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
        <td style={styles.td}>{b.ad}</td>
        <td style={styles.td}>{b.referans}</td>
        <td style={styles.td}><b>{b.paket}</b></td>

      <td style={styles.td}>
  {baslangic ? baslangic.toLocaleDateString("tr-TR") : "-"}
</td>

<td style={styles.td}>
  {bitis ? bitis.toLocaleDateString("tr-TR") : "-"}
</td>


 <td style={styles.td}>
  {gun !== null && (
    <>
      {/* AKTİF PAKET */}
      {gun > 0 && (
        <span style={{
          padding: "4px 10px",
          borderRadius: 20,
          fontWeight: 700,
          background:
            gun <= 3 ? "#fecaca" :
            gun <= 7 ? "#fde68a" :
            gun <= 30 ? "#bfdbfe" : "#dcfce7",
          color:
            gun <= 3 ? "#991b1b" :
            gun <= 7 ? "#92400e" :
            gun <= 30 ? "#1e40af" : "#166534"
        }}>
          {gun} gün kaldı
        </span>
      )}

      {/* UPGRADE EDİLMİŞ PAKET */}
      {gun <= 0 && b.upgraded === true && (
        <span style={{
          padding: "4px 10px",
          borderRadius: 20,
          fontWeight: 700,
          background: "#dbeafe",
          color: "#1e40af"
        }}>
          🔵 Paket yükseltildi
        </span>
      )}

      {/* GERÇEKTEN SÜRESİ DOLMUŞ */}
      {gun <= 0 && !b.upgraded && (
        <span style={{
          padding: "4px 10px",
          borderRadius: 20,
          fontWeight: 700,
          background: "#fecaca",
          color: "#991b1b"
        }}>
          🔴 Süresi doldu
        </span>
      )}
    </>
  )}
</td>


   <td style={styles.td}>{b.durum}</td>

<td style={styles.td}>
  {b.durum === "Beklemede" && (
    <button
      style={styles.approveBtn}
      onClick={() => onaylaPaket(b)}
    >
      Onayla
    </button>
  )}
</td>
      </tr>
    );
  })}
</tbody>
</table>
</div>
</div>



{/* ================= ÖDEME TALEPLERİ (AKORDİYON) ================= */}
<div style={{ marginTop: 40 }}>
  <div style={styles.card}>
    <div
      onClick={() => setOdemeOpen(!odemeOpen)}
      style={{
        display: "flex",
        justifyContent: "space-between",
        cursor: "pointer",
        fontWeight: 800,
        fontSize: 18
      }}
    >
      <span>💸 Ödeme Talepleri (Referans Kazanç)</span>
      <span>{odemeOpen ? "−" : "+"}</span>
    </div>

    {odemeOpen && (
      <div style={{ marginTop: 20, overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#f1f5f9" }}>
              <th style={styles.th}>Kullanıcı</th>
              <th style={styles.th}>Tutar</th>
              <th style={styles.th}>Talep Tarihi</th>
              <th style={styles.th}>Durum</th>
              <th style={styles.th}>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {odemeTalepleri.map(o => (
              <tr key={o.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
                <td style={styles.td}>{o.user_name}</td>
                <td style={styles.td}><b>{Number(o.amount).toFixed(2)} ₺</b></td>
                <td style={styles.td}>
                  {new Date(o.created_at).toLocaleDateString("tr-TR")}
                </td>
                <td style={styles.td}>{o.status}</td>
                <td style={styles.td}>
                  {o.status === "requested" && (
                    <button
                      style={styles.approveBtn}
                      onClick={async () => {
                        await fetch(`${API}/admin/payout-approve/${o.id}`, {
                          method: "POST",
                          headers: { Authorization: `Bearer ${token}` }
                        });
                        fetchOdemeTalepleri();
                      }}
                    >
                      Ödemeyi Onayla
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
</div>


{/* ================= NETWORK KULLANICILARI ================= */}
<div style={{ marginTop: 40 }}>
  <div style={styles.card}>
    <div
      onClick={() => setNetworkOpen(!networkOpen)}
      style={{
        display: "flex",
        justifyContent: "space-between",
        cursor: "pointer",
        fontWeight: 800,
        fontSize: 18
      }}
    >
      <span>🌐 Network Kullanıcıları</span>
      <span>{networkOpen ? "−" : "+"}</span>
    </div>

    {networkOpen && (
      <div style={{ marginTop: 20, overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#f1f5f9" }}>
              <th style={styles.th}>ID</th>
              <th style={styles.th}>Ad Soyad</th>
              <th style={styles.th}>Email</th>
              <th style={styles.th}>Durum</th>
              <th style={styles.th}>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {networkUsers.map(u => (
              <tr key={u.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
                <td style={styles.td}>{u.id}</td>
<td style={styles.td}>{u.kurum_adi}</td>
                           <td style={styles.td}>{u.email}</td>
                <td style={styles.td}>{u.network_status}</td>
                <td style={styles.td}>
                  <button
                    style={{
                      ...styles.deleteBtn,
                      background: "#dc2626"
                    }}
                    onClick={() => deactivateNetworkUser(u.id)}
                  >
                    Network’ten Çıkar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
</div>



</div>



</div>
  );
}

/* ================= STYLES ================= */
const styles = {
  page: {
    minHeight: "100vh",
    padding: 24,
    background:
      "radial-gradient(circle at top left, rgba(37,99,235,.12), transparent 28%), linear-gradient(135deg, #f8fafc 0%, #eef2ff 45%, #fff7ed 100%)",
    color: "#0f172a",
    fontFamily:
      "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
  },

  hero: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 18,
    marginBottom: 22,
    padding: "24px 26px",
    borderRadius: 24,
    background:
      "linear-gradient(135deg, rgba(15,23,42,.98), rgba(30,64,175,.96))",
    color: "#fff",
    boxShadow: "0 24px 60px rgba(15,23,42,.22)",
    position: "relative",
    overflow: "hidden"
  },

  kicker: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "6px 10px",
    borderRadius: 999,
    background: "rgba(255,255,255,.12)",
    color: "#bfdbfe",
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: ".04em",
    textTransform: "uppercase",
    marginBottom: 10
  },

  heroTitle: {
    margin: 0,
    fontSize: 34,
    lineHeight: 1.1,
    fontWeight: 900,
    letterSpacing: "-.04em"
  },

  heroText: {
    margin: "10px 0 0",
    maxWidth: 680,
    color: "#dbeafe",
    fontSize: 15,
    lineHeight: 1.6,
    fontWeight: 500
  },

  heroActions: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
    justifyContent: "flex-end"
  },

  heroBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "10px 13px",
    borderRadius: 999,
    background: "rgba(255,255,255,.12)",
    border: "1px solid rgba(255,255,255,.18)",
    color: "#fff",
    fontSize: 13,
    fontWeight: 800,
    whiteSpace: "nowrap"
  },

  heroDot: {
    width: 9,
    height: 9,
    borderRadius: "50%",
    background: "#22c55e",
    boxShadow: "0 0 0 5px rgba(34,197,94,.18)"
  },

  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: 14,
    marginBottom: 20
  },

subeTabs: {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 8,
  marginBottom: 10,
},

subeTabBtn: {
  border: "none",
  padding: "11px 12px",
  borderRadius: 12,
  fontWeight: 900,
  cursor: "pointer",
},

subeHelper: {
  padding: 12,
  borderRadius: 12,
  background: "#fff7ed",
  border: "1px solid #fed7aa",
  color: "#9a3412",
  fontSize: 13,
  fontWeight: 750,
  lineHeight: 1.45,
  marginBottom: 12,
},

linkedBadge: {
  padding: "3px 8px",
  borderRadius: 999,
  background: "#dbeafe",
  color: "#1d4ed8",
  fontSize: 11,
  fontWeight: 900,
},

subeLinkBtn: {
  gridColumn: "1 / -1",
  border: "none",
  background: "linear-gradient(135deg, #f97316, #ea580c)",
  color: "#fff",
  padding: 12,
  borderRadius: 10,
  fontWeight: 900,
  cursor: "pointer",
},

subeDangerLightBtn: {
  border: "none",
  background: "#fff7ed",
  color: "#c2410c",
  padding: "8px 10px",
  borderRadius: 10,
  fontWeight: 900,
  cursor: "pointer",
},

  statCard: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    padding: 18,
    borderRadius: 20,
    background: "rgba(255,255,255,.86)",
    border: "1px solid rgba(226,232,240,.95)",
    boxShadow: "0 16px 38px rgba(15,23,42,.08)",
    backdropFilter: "blur(12px)"
  },

  statIcon: {
    width: 44,
    height: 44,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 16,
    background: "linear-gradient(135deg, #eff6ff, #fff7ed)",
    fontSize: 22,
    boxShadow: "inset 0 0 0 1px rgba(37,99,235,.08)"
  },

  statLabel: {
    fontSize: 12,
    color: "#64748b",
    fontWeight: 800,
    textTransform: "uppercase",
    letterSpacing: ".04em"
  },

  statValue: {
    marginTop: 2,
    fontSize: 24,
    fontWeight: 900,
    color: "#0f172a",
    letterSpacing: "-.03em"
  },

  layout: {
    display: "grid",
    gridTemplateColumns: "minmax(320px, .85fr) minmax(420px, 1.15fr)",
    gap: 20,
    alignItems: "start"
  },

  card: {
    background: "rgba(255,255,255,.92)",
    borderRadius: 24,
    padding: 22,
    border: "1px solid rgba(226,232,240,.95)",
    boxShadow: "0 24px 60px rgba(15,23,42,.10)",
    backdropFilter: "blur(14px)"
  },

  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 14,
    marginBottom: 18
  },

  cardEyebrow: {
    color: "#2563eb",
    fontSize: 12,
    fontWeight: 900,
    textTransform: "uppercase",
    letterSpacing: ".05em",
    marginBottom: 4
  },

  cardTitle: {
    margin: 0,
    fontSize: 21,
    fontWeight: 900,
    color: "#0f172a",
    letterSpacing: "-.03em"
  },

  cardIcon: {
    width: 42,
    height: 42,
    borderRadius: 16,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #2563eb, #f97316)",
    color: "#fff",
    fontSize: 20,
    fontWeight: 900,
    boxShadow: "0 12px 28px rgba(37,99,235,.25)"
  },

  formGrid: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: 10
  },

  input: {
    width: "100%",
    boxSizing: "border-box",
    padding: "13px 14px",
    borderRadius: 14,
    border: "1px solid #dbe3ef",
    marginBottom: 0,
    outline: "none",
    background: "#f8fafc",
    color: "#0f172a",
    fontSize: 14,
    fontWeight: 650,
    transition: "all .18s ease"
  },

  searchInput: {
    width: "100%",
    boxSizing: "border-box",
    padding: "14px 15px",
    borderRadius: 16,
    border: "1px solid #dbe3ef",
    marginBottom: 14,
    outline: "none",
    background: "#f8fafc",
    color: "#0f172a",
    fontSize: 14,
    fontWeight: 700
  },

  primaryBtn: {
    width: "100%",
    padding: 15,
    borderRadius: 16,
    marginTop: 14,
    background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
    color: "#fff",
    fontWeight: 900,
    border: "none",
    cursor: "pointer",
    boxShadow: "0 16px 32px rgba(37,99,235,.25)"
  },

  logoutBtn: {
    padding: "11px 16px",
    borderRadius: 14,
    background: "#fff",
    color: "#0f172a",
    border: "none",
    fontWeight: 900,
    cursor: "pointer",
    boxShadow: "0 12px 28px rgba(15,23,42,.18)"
  },

  bayiList: {
    display: "grid",
    gap: 10
  },

  accordion: {
    border: "1px solid #e2e8f0",
    borderRadius: 18,
    padding: 0,
    marginBottom: 0,
    background: "#fff",
    overflow: "hidden",
    boxShadow: "0 10px 26px rgba(15,23,42,.05)"
  },

  summary: {
    cursor: "pointer",
    fontWeight: 700,
    listStyle: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    padding: 14
  },

  bayiSummaryLeft: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    minWidth: 0
  },

  avatar: {
    width: 46,
    height: 46,
    minWidth: 46,
    borderRadius: 16,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #f97316, #2563eb)",
    color: "#fff",
    fontSize: 18,
    fontWeight: 900,
    boxShadow: "0 12px 28px rgba(249,115,22,.22)"
  },

  bayiName: {
    color: "#0f172a",
    fontSize: 15,
    fontWeight: 900,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 320
  },

  bayiMeta: {
    marginTop: 3,
    color: "#64748b",
    fontSize: 12,
    fontWeight: 700
  },

  statusBadge: {
    padding: "7px 10px",
    borderRadius: 999,
    background: "#dcfce7",
    color: "#166534",
    fontSize: 12,
    fontWeight: 900,
    whiteSpace: "nowrap"
  },

  detail: {
    marginTop: 0,
    padding: "0 14px 14px",
    borderTop: "1px solid #f1f5f9"
  },

  detailGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: 10,
    marginTop: 12
  },

  infoBox: {
    padding: 12,
    borderRadius: 14,
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    color: "#0f172a"
  },

  infoLabel: {
    display: "block",
    color: "#64748b",
    fontSize: 11,
    fontWeight: 900,
    textTransform: "uppercase",
    letterSpacing: ".04em",
    marginBottom: 5
  },

  deleteBtn: {
    marginTop: 12,
    width: "100%",
    padding: 12,
    borderRadius: 14,
    background: "linear-gradient(135deg, #f97316, #dc2626)",
    color: "#fff",
    border: "none",
    fontWeight: 900,
    cursor: "pointer",
    boxShadow: "0 12px 26px rgba(249,115,22,.22)"
  },

  emptyState: {
    padding: 28,
    borderRadius: 18,
    background: "#f8fafc",
    border: "1px dashed #cbd5e1",
    color: "#64748b",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 6,
    textAlign: "center",
    fontSize: 14
  },

  emptyIcon: {
    fontSize: 28,
    marginBottom: 4
  },

  th: {
    padding: 12,
    fontWeight: 900,
    fontSize: 13,
    color: "#334155",
    borderBottom: "2px solid #e5e7eb",
    whiteSpace: "nowrap"
  },

  td: {
    padding: 12,
    fontSize: 14,
    color: "#0f172a",
    whiteSpace: "nowrap"
  },

  approveBtn: {
    padding: "9px 14px",
    borderRadius: 12,
    background: "linear-gradient(135deg, #16a34a, #15803d)",
    color: "#fff",
    border: "none",
    fontWeight: 900,
    cursor: "pointer",
    boxShadow: "0 10px 22px rgba(22,163,74,.22)"
  },

  message: {
    padding: 14,
    borderRadius: 16,
    marginBottom: 16,
    fontWeight: 800,
    border: "1px solid rgba(226,232,240,.85)",
    boxShadow: "0 12px 28px rgba(15,23,42,.07)"
  },

  loginPage: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background:
      "radial-gradient(circle at top, rgba(37,99,235,.16), transparent 30%), linear-gradient(135deg, #f8fafc, #eef2ff)"
  },
subeBox: {
  marginTop: 16,
  padding: 16,
  borderRadius: 14,
  background: "#f8fafc",
  border: "1px solid #e2e8f0",
},

subeTop: {
  display: "flex",
  justifyContent: "space-between",
  gap: 12,
  alignItems: "flex-start",
  marginBottom: 12,
},

subeTitle: {
  fontSize: 16,
  fontWeight: 900,
  color: "#0f172a",
},

subeDesc: {
  fontSize: 13,
  color: "#64748b",
  marginTop: 4,
  lineHeight: 1.4,
},

subeToggleBtn: {
  border: "none",
  color: "#fff",
  padding: "9px 12px",
  borderRadius: 999,
  fontWeight: 800,
  cursor: "pointer",
  whiteSpace: "nowrap",
},

subeRefreshBtn: {
  width: "100%",
  padding: 11,
  borderRadius: 10,
  border: "1px solid #bfdbfe",
  background: "#eff6ff",
  color: "#1d4ed8",
  fontWeight: 800,
  cursor: "pointer",
  marginBottom: 12,
},

subeList: {
  display: "grid",
  gap: 10,
  marginBottom: 14,
},

subeItem: {
  display: "flex",
  justifyContent: "space-between",
  gap: 12,
  alignItems: "center",
  padding: 12,
  borderRadius: 12,
  background: "#fff",
  border: "1px solid #e5e7eb",
},

subeName: {
  display: "flex",
  alignItems: "center",
  gap: 8,
  fontWeight: 900,
  color: "#0f172a",
},

subeMeta: {
  fontSize: 12,
  color: "#64748b",
  marginTop: 3,
},

defaultBadge: {
  padding: "3px 8px",
  borderRadius: 999,
  background: "#dcfce7",
  color: "#166534",
  fontSize: 11,
  fontWeight: 900,
},

passiveBadge: {
  padding: "3px 8px",
  borderRadius: 999,
  background: "#fee2e2",
  color: "#991b1b",
  fontSize: 11,
  fontWeight: 900,
},
subePassiveBtn: {
  border: "none",
  background: "#fee2e2",
  color: "#991b1b",
  padding: "8px 10px",
  borderRadius: 10,
  fontWeight: 800,
  cursor: "pointer",
},

subeEmpty: {
  padding: 12,
  borderRadius: 10,
  background: "#fff",
  color: "#64748b",
  fontSize: 13,
  border: "1px dashed #cbd5e1",
},

subeForm: {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 10,
},

subeAddBtn: {
  gridColumn: "1 / -1",
  border: "none",
  background: "#2563eb",
  color: "#fff",
  padding: 12,
  borderRadius: 10,
  fontWeight: 900,
  cursor: "pointer",
},
referansBox: {
  marginTop: 16,
  padding: 16,
  borderRadius: 16,
  background: "linear-gradient(135deg, #ffffff, #f8fafc)",
  border: "1px solid #e2e8f0",
  boxShadow: "0 14px 34px rgba(15,23,42,.06)",
},

referansTop: {
  display: "flex",
  justifyContent: "space-between",
  gap: 12,
  alignItems: "flex-start",
  marginBottom: 14,
},

referansTitle: {
  fontSize: 16,
  fontWeight: 900,
  color: "#0f172a",
},

referansDesc: {
  fontSize: 13,
  color: "#64748b",
  marginTop: 4,
  lineHeight: 1.45,
},

referansInfoBadge: {
  padding: "7px 12px",
  borderRadius: 999,
  background: "#eff6ff",
  color: "#1d4ed8",
  border: "1px solid #bfdbfe",
  fontSize: 12,
  fontWeight: 900,
  whiteSpace: "nowrap",
},

referansForm: {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 10,
  padding: 12,
  borderRadius: 14,
  background: "#f8fafc",
  border: "1px solid #e2e8f0",
},

referansTextArea: {
  gridColumn: "1 / -1",
  minHeight: 78,
  padding: 12,
  borderRadius: 12,
  border: "1px solid #d1d5db",
  outline: "none",
  resize: "vertical",
  fontFamily: "inherit",
  fontWeight: 700,
  color: "#0f172a",
  background: "#fff",
},

referansActions: {
  gridColumn: "1 / -1",
  display: "flex",
  gap: 10,
  flexWrap: "wrap",
},

referansSaveBtn: {
  flex: 1,
  border: "none",
  background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
  color: "#fff",
  padding: 12,
  borderRadius: 12,
  fontWeight: 900,
  cursor: "pointer",
  boxShadow: "0 12px 24px rgba(37,99,235,.22)",
},

referansCancelBtn: {
  border: "none",
  background: "#e2e8f0",
  color: "#0f172a",
  padding: "12px 16px",
  borderRadius: 12,
  fontWeight: 900,
  cursor: "pointer",
},

referansList: {
  display: "grid",
  gap: 10,
  marginTop: 14,
},

referansItem: {
  display: "flex",
  justifyContent: "space-between",
  gap: 12,
  alignItems: "stretch",
  padding: 14,
  borderRadius: 14,
  background: "#fff",
  border: "1px solid #e5e7eb",
},

referansItemMain: {
  flex: 1,
  minWidth: 0,
},

referansItemHeader: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 10,
  flexWrap: "wrap",
  marginBottom: 6,
  color: "#0f172a",
},

referansSmallBadge: {
  padding: "5px 10px",
  borderRadius: 999,
  fontSize: 11,
  fontWeight: 900,
  background: "#fff7ed",
  color: "#9a3412",
  border: "1px solid #fed7aa",
  whiteSpace: "nowrap",
},

referansMeta: {
  fontSize: 12,
  color: "#64748b",
  marginTop: 3,
},

referansNote: {
  marginTop: 10,
  padding: 10,
  borderRadius: 10,
  background: "#f8fafc",
  border: "1px dashed #cbd5e1",
  color: "#475569",
  fontSize: 12,
  lineHeight: 1.45,
},

referansItemActions: {
  display: "flex",
  flexDirection: "column",
  gap: 8,
  minWidth: 100,
},

referansEditBtn: {
  border: "none",
  background: "#dbeafe",
  color: "#1e40af",
  padding: "9px 10px",
  borderRadius: 10,
  fontWeight: 900,
  cursor: "pointer",
},

referansDeleteBtn: {
  border: "none",
  background: "#fee2e2",
  color: "#991b1b",
  padding: "9px 10px",
  borderRadius: 10,
  fontWeight: 900,
  cursor: "pointer",
},

referansEmpty: {
  padding: 14,
  borderRadius: 12,
  background: "#fff",
  color: "#64748b",
  fontSize: 13,
  border: "1px dashed #cbd5e1",
},

kurumEditBox: {
  marginTop: 14,
  padding: 16,
  borderRadius: 16,
  background: "linear-gradient(135deg, #ffffff, #f8fafc)",
  border: "1px solid #e2e8f0",
  boxShadow: "0 12px 28px rgba(15,23,42,.05)",
},

kurumEditTop: {
  display: "flex",
  justifyContent: "space-between",
  gap: 12,
  alignItems: "flex-start",
},

kurumEditTitle: {
  fontSize: 16,
  fontWeight: 900,
  color: "#0f172a",
},

kurumEditDesc: {
  fontSize: 13,
  color: "#64748b",
  marginTop: 4,
  lineHeight: 1.45,
},

kurumEditToggleBtn: {
  border: "none",
  background: "linear-gradient(135deg, #f97316, #ea580c)",
  color: "#fff",
  padding: "10px 14px",
  borderRadius: 999,
  fontWeight: 900,
  cursor: "pointer",
  whiteSpace: "nowrap",
  boxShadow: "0 10px 20px rgba(249,115,22,.22)",
},

kurumEditForm: {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 10,
  marginTop: 14,
  padding: 12,
  borderRadius: 14,
  background: "#f8fafc",
  border: "1px solid #e2e8f0",
},

kurumEditPasswordNote: {
  display: "flex",
  alignItems: "center",
  padding: "10px 12px",
  borderRadius: 12,
  background: "#eff6ff",
  border: "1px solid #bfdbfe",
  color: "#1d4ed8",
  fontSize: 12,
  fontWeight: 800,
},

kurumEditActions: {
  gridColumn: "1 / -1",
  display: "flex",
  gap: 10,
  flexWrap: "wrap",
},

kurumEditSaveBtn: {
  flex: 1,
  border: "none",
  background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
  color: "#fff",
  padding: 12,
  borderRadius: 12,
  fontWeight: 900,
  cursor: "pointer",
  boxShadow: "0 12px 24px rgba(37,99,235,.22)",
},

kurumEditCancelBtn: {
  border: "none",
  background: "#e2e8f0",
  color: "#0f172a",
  padding: "12px 16px",
  borderRadius: 12,
  fontWeight: 900,
  cursor: "pointer",
},
kademeTabs: {
  gridColumn: "1 / -1",
  display: "grid",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  gap: 8,
},

kademeBtn: {
  border: "none",
  padding: "11px 12px",
  borderRadius: 12,
  fontWeight: 900,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 8,
},

kademeRate: {
  fontSize: 12,
  fontWeight: 900,
  opacity: 0.9,
},

hakedisPreviewMini: {
  gridColumn: "1 / -1",
  display: "grid",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  gap: 10,
  padding: 12,
  borderRadius: 14,
  background: "#fff7ed",
  border: "1px solid #fed7aa",
  color: "#9a3412",
},

dateFieldBox: {
  display: "grid",
  gap: 6,
},

dateLabel: {
  fontSize: 12,
  fontWeight: 900,
  color: "#475569",
},
kademeManualBox: {
  display: "grid",
  gridTemplateColumns: "1fr 110px",
  gap: 8,
  alignItems: "center",
  padding: 8,
  borderRadius: 14,
  border: "1px solid #e2e8f0",
},

kademeSelectBtn: {
  border: "none",
  padding: "11px 12px",
  borderRadius: 12,
  fontWeight: 900,
  cursor: "pointer",
},

kademeInput: {
  width: "100%",
  border: "1px solid #cbd5e1",
  borderRadius: 10,
  padding: "10px 9px",
  fontWeight: 900,
  outline: "none",
},


  loginCard: {
    background: "rgba(255,255,255,.94)",
    padding: 32,
    borderRadius: 24,
    width: 380,
    border: "1px solid #e2e8f0",
    boxShadow: "0 24px 70px rgba(15,23,42,.16)"
  }
};

/* =====================================================
   MOBILE RESPONSIVE OVERRIDE
===================================================== */

if (typeof window !== "undefined") {
  const isMobile = window.innerWidth < 768;

  if (isMobile) {
    styles.page.padding = 12;

    styles.hero.flexDirection = "column";
    styles.hero.alignItems = "flex-start";
    styles.hero.padding = 18;
    styles.heroTitle.fontSize = 28;

    styles.heroActions.width = "100%";
    styles.heroActions.justifyContent = "space-between";

    styles.statsGrid.gridTemplateColumns = "1fr 1fr";
    styles.statCard.padding = 14;

    styles.layout.gridTemplateColumns = "1fr";

    styles.card.padding = 16;

    styles.logoutBtn.width = "100%";

    styles.loginCard.width = "92%";

styles.subeForm.gridTemplateColumns = "1fr";
styles.subeTabs.gridTemplateColumns = "1fr";
    styles.bayiName.maxWidth = 180;

    styles.th.fontSize = 12;
    styles.td.fontSize = 13;

styles.referansTop.flexDirection = "column";
styles.referansInfoBadge.width = "100%";
styles.referansInfoBadge.textAlign = "center";
styles.referansForm.gridTemplateColumns = "1fr";
styles.referansItem.flexDirection = "column";
styles.referansItemActions.flexDirection = "row";
styles.referansItemActions.minWidth = "100%";
styles.referansEditBtn.flex = 1;
styles.referansDeleteBtn.flex = 1;
styles.kurumEditTop.flexDirection = "column";
styles.kurumEditToggleBtn.width = "100%";
styles.kurumEditForm.gridTemplateColumns = "1fr";
styles.kurumEditPasswordNote.gridColumn = "1 / -1";
styles.kurumEditActions.flexDirection = "column";
styles.kurumEditSaveBtn.width = "100%";
styles.kurumEditCancelBtn.width = "100%";
styles.kademeTabs.gridTemplateColumns = "1fr";
styles.hakedisPreviewMini.gridTemplateColumns = "1fr";


    // ✅ ŞUBE MOBİL DÜZENİ
    styles.subeTop.flexDirection = "column";
    styles.subeToggleBtn.width = "100%";
    styles.subeForm.gridTemplateColumns = "1fr";
    styles.subeItem.flexDirection = "column";
    styles.subeItem.alignItems = "stretch";
  }
}